import React from 'react';
import PropTypes from 'prop-types';
import BaseBadge from '../BaseBadge';
import styles from './styles.scss';

const TransactionBadge = ({ transaction, className, ...rest }) => {
  const styleKey = transaction.type;
  const mergedClassName = `${transaction.is_modified ? styles['modified'] : styles[styleKey]} ${className}`;
  const badgeLabel = () => {
    switch (transaction.type) {
      case 'topup':
        return 'チャージ';
      case 'payment':
        return '支払い';
      case 'transfer':
        return '送金';
      case 'exchange_inflow':
        return '交換（流入）';
      case 'exchange_outflow':
        return '交換（流出）';
      case 'expire':
        return '失効';
      case 'cashback':
        return '返金';
      default:
        return '不明';
    }
  };
  return (
    <BaseBadge className={mergedClassName} {...rest}>{badgeLabel()}</BaseBadge>
  );
};

TransactionBadge.propTypes = {
  transaction: PropTypes.shape({ type: PropTypes.string, is_modified: PropTypes.bool }).isRequired,
  type: PropTypes.string,
  className: PropTypes.string,
};

TransactionBadge.defaultProps = {
  type: '',
  className: '',
};

export default TransactionBadge;
